import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getMipSecurities } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service.ts';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams.ts';

export const useMipSecurities = () => {
	const { mipId } = useRequiredParams('mipId');
	const query = useQuery({
		queryKey: [API_PATHS.SECURITY_MIP_SECURITIES_MIPID_GET, mipId],
		queryFn: () => getMipSecurities(mipId),
	});

	return {
		data: query.data?.payload ?? undefined,
		isLoading: query.isLoading,
		isError: query.isError,
	};
};
